module.exports = __webpack_public_path__ + "static/media/card.1914f8e7.svg";